import React from 'react'
import { Modal, Button} from 'react-bootstrap'

class ConfirmModal extends React.Component {
  render() {
    return <Modal show={this.props.show} onHide={this.props.onHide}>
      <Modal.Header>
        <Modal.Title>{this.props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {this.props.body}
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle='primary' onClick={this.props.onSubmit}>{this.props.confirmbuttontext}</Button>
        <Button bsStyle='default' onClick={this.props.onHide}>Annuleren</Button>
      </Modal.Footer>
    </Modal>
  }
}

export default ConfirmModal


// WEBPACK FOOTER //
// ./src/components/ConfirmModal.js